module.exports = __webpack_public_path__ + "static/headshot-ted-reed-2x.bda4e32d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-ted-reed-2x.jpg
// module id = 141
// module chunks = 35783957827783 152909308826437